import { useQuery } from '@tanstack/react-query';

import { useSelectedStore } from '@/hooks';
import { useEcomStoreSelector } from '@/data';
import { buildSearchBodyFromParams, useSearchService } from '@/opensearch';
import { getProductsFromOpenSearchResponse } from 'utils/opensearch';

export const useSearchProductsByTerm = (searchTerm: string) => {
  const { store } = useSelectedStore();
  const { customer_type, provider_inventory_location_id } =
    useEcomStoreSelector(['customer_type', 'provider_inventory_location_id']);
  const { search } = useSearchService();

  const dispensaryName = store?.shortName ?? '';
  const queryKey = [
    dispensaryName,
    customer_type,
    'products-by-seo-name',
    searchTerm,
    provider_inventory_location_id,
  ];

  const { data, isLoading, error, isError } = useQuery({
    queryKey,
    queryFn: async () => {
      const { searchBody } = buildSearchBodyFromParams({
        limit: 10,
        searchParams: {
          query: searchTerm,
        },
        filters: {
          isAboveThreshold: [true],
          isHideFromMenu: [false],
        },
      });

      const result = await search({ searchBody });
      const products = getProductsFromOpenSearchResponse(result);

      return { products };
    },
  });

  return { isLoading, error, isError, products: data?.products ?? [] };
};
